/**
 * 老师跟踪记录 content 里【附件】URL → 缩略图 / 链接（不改后端写入格式）
 */

var IMG_RE = /\.(jpg|jpeg|png|gif|bmp|webp)(\?|$)/i
var OFFICE_RE = /\.(doc|docx|xls|xlsx|ppt|pptx|odt|ods|odp)(\?|$)/i
var URL_RE = /https?:\/\/\S+/g

var THUMB_STYLE = {
  width: '48px',
  height: '48px',
  objectFit: 'cover',
  marginRight: '4px',
  marginBottom: '4px',
  borderRadius: '3px',
  cursor: 'pointer',
  verticalAlign: 'middle'
}

export function isImageUrl (url) {
  return IMG_RE.test(url || '')
}

export function isOfficeUrl (url) {
  return OFFICE_RE.test(url || '')
}

/**
 * @returns {{ prefix: string, items: Array<{name: string, url: string}>, plain: string|null }}
 * plain 非空表示整段按纯文本展示（无 URL）
 */
export function parseTrackContentAttach (content) {
  var text = content == null ? '' : String(content)
  if (!text) {
    return { prefix: '', items: [], plain: '' }
  }
  var urls = text.match(URL_RE)
  if (!urls || !urls.length) {
    return { prefix: '', items: [], plain: text }
  }

  if (text.indexOf('【附件】') === 0) {
    var body = text.slice('【附件】'.length)
    var parts = body.split(/[；;]/).map(function (s) { return s.trim() }).filter(Boolean)
    var items = []
    parts.forEach(function (part) {
      var m = part.match(/^(.*?)\s+(https?:\/\/\S+)\s*$/)
      if (m) {
        items.push({ name: (m[1] || '').trim() || '未命名', url: m[2] })
      } else {
        var u = part.match(URL_RE)
        if (u && u[0]) {
          items.push({ name: part.replace(u[0], '').trim() || '未命名', url: u[0] })
        }
      }
    })
    if (items.length) {
      return { prefix: '【附件】', items: items, plain: null }
    }
  }

  // 非【附件】前缀：按出现顺序拆文本与 URL
  var items2 = []
  var last = 0
  var re = /https?:\/\/\S+/g
  var match
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) {
      items2.push({ type: 'text', text: text.slice(last, match.index) })
    }
    items2.push({ type: 'url', name: '', url: match[0] })
    last = match.index + match[0].length
  }
  if (last < text.length) {
    items2.push({ type: 'text', text: text.slice(last) })
  }
  return { prefix: '', items: items2, plain: null, mixed: true }
}

/**
 * @param {Function} h Vue createElement
 * @param {string} content
 * @param {Function} onViewImages (imageUrls: string[], index: number) => void
 */
export function renderTrackContentAttach (h, content, onViewImages) {
  var parsed = parseTrackContentAttach(content)
  if (parsed.plain != null) {
    return h('span', parsed.plain)
  }

  var nodes = []
  var imageUrls = []

  function collectImages (list) {
    list.forEach(function (it) {
      var url = it.url
      if (url && isImageUrl(url)) {
        imageUrls.push(url)
      }
    })
  }

  if (parsed.mixed) {
    collectImages(parsed.items.filter(function (it) { return it.type === 'url' }))
  } else {
    collectImages(parsed.items)
  }

  if (parsed.prefix) {
    nodes.push(h('span', { style: { marginRight: '6px', verticalAlign: 'middle' } }, parsed.prefix))
  }

  function pushUrlNode (name, url) {
    if (isImageUrl(url)) {
      var imgIndex = imageUrls.indexOf(url)
      nodes.push(h('img', {
        attrs: { src: url, alt: name || '' },
        style: THUMB_STYLE,
        on: {
          click: function () {
            if (typeof onViewImages === 'function') {
              onViewImages(imageUrls, imgIndex < 0 ? 0 : imgIndex)
            }
          }
        }
      }))
    } else if (isOfficeUrl(url)) {
      nodes.push(h('a', {
        style: { display: 'inline-block', marginRight: '8px', verticalAlign: 'middle' },
        attrs: {
          href: 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url),
          target: '_blank'
        }
      }, name || '预览'))
    } else {
      nodes.push(h('a', {
        style: { display: 'inline-block', marginRight: '8px', verticalAlign: 'middle' },
        attrs: { href: url, target: '_blank' }
      }, name || '打开'))
    }
  }

  if (parsed.mixed) {
    parsed.items.forEach(function (it) {
      if (it.type === 'text') {
        if (it.text) {
          nodes.push(h('span', it.text))
        }
      } else {
        pushUrlNode(it.name, it.url)
      }
    })
  } else {
    parsed.items.forEach(function (it) {
      pushUrlNode(it.name, it.url)
    })
  }

  return h('div', { style: { lineHeight: '1.4' } }, nodes)
}



// WEBPACK FOOTER //
// ./src/utils/trackContentAttach.js